module.exports = __webpack_public_path__ + "static/media/icon_exclamation_mark.3a0800cb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/game/textures/icon_exclamation_mark.png
 ** module id = 616
 ** module chunks = 0
 **/